import React from 'react';
import { Link } from 'react-router-dom';
import type { IconType } from 'react-icons';
import { BrowseIcon, type BrowseAccent } from './BrowseIcon';

export interface BrowseTile {
  to: string;
  title: string;
  subtitle: string;
  icon: IconType;
  accent: BrowseAccent;
}

/*
 * One tile on /browse.
 *
 * Extracted from Browse.tsx so a tile can be rendered by something other than
 * that file — the meanings tiles need their own component, because they are the
 * only ones on the page whose existence depends on fetched data, and hooks in
 * Browse itself break the tenant tests that re-require it under a reset module
 * registry.
 *
 * h-full so a grid row's tiles match height whatever their subtitle wraps to —
 * without it the two-line subtitles leave ragged tiles next to one-line ones.
 */
export const BrowseCard: React.FC<BrowseTile> = ({ to, title, subtitle, icon, accent }) => (
  <Link
    to={to}
    className="group flex h-full items-center gap-4 rounded-2xl border border-light bg-bg-2/60 px-5 py-4 hover:bg-white/5 hover:border-strong transition-colors"
  >
    <BrowseIcon icon={icon} accent={accent} />
    <span className="min-w-0">
      <span className="block text-h3 font-display font-semibold text-text-primary">{title}</span>
      <span className="block text-small text-text-tertiary mt-1">{subtitle}</span>
    </span>
  </Link>
);
